// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"c964e242","228":"60a1e29d","390":"09244082","455":"d6ef1a90","799":"6c6e8c6b","977":"0296d865"}[chunkId] + ".chunk.js";
};